import {
  microFrontendsMetadataHome,
  microFrontendsMetadataLoan,
  microFrontendsMetadataSteps,
  microFrontendsMetadataFTD,
  microFrontendsMetadataEnrollment,
  microFrontendsMetadataBiometrics,
} from './routes.config';

export const microFrontendsMetadata = [
  microFrontendsMetadataHome,
  microFrontendsMetadataSteps,
  microFrontendsMetadataLoan,
  microFrontendsMetadataFTD,
  microFrontendsMetadataEnrollment,
  microFrontendsMetadataBiometrics,
];
